"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useToast } from "@/components/ui/use-toast";

import { deleteAlert } from "@/services/alerts";

import { queryKeys } from "../query-key";

export const useDeleteAlert = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (id: string) => deleteAlert(id),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: queryKeys.alerts });

      toast({
        title: "Alerta removido com sucesso!",
        variant: "default",
      });
    },
    onError: (error) => {
      toast({
        title: "Erro ao remover alerta",
        description:
          error instanceof Error
            ? error.message
            : "Ocorreu um erro ao remover o alerta",
        variant: "destructive",
      });
    },
  });
};
